<template>
  <!-- 智慧云端 -->
  <div id="smartcloud" class="listStyle">
    <div id="goToHere1"></div>

    <div v-if="userId || wxgenerateid">
      <!-- 点击弹出搜索弹框 -->
      <div @click="alertPopup" class="openPopup">
        
        <van-sticky offset-top="2.24rem">
          <span>
            <img width="22" height="20"
            src="../../assets/index/wenjianjia.png"
            />
          </span>
          <van-cell
            v-if="chooseDir === '全部文件夹'"
            title="当前文件夹"
            is-link
            value="选择文件夹"
          />
          <van-cell
            v-else
            :title="'当前文件夹：' + chooseDir"
            is-link
            value="选择文件夹"
          />
        </van-sticky>
      </div>
      <div class="top">
        <!-- 法规分类 -->
        <classification-rules
          ref="classification"
          @showGetData="showGetData"
          @changeTagid="changeTagid"
          @getTree="getTree"
          @showBackNav="showBackNav"
          :classifytag="data"
          :stime="stime"
          :etime="etime"
          :searchText="searchText"
        ></classification-rules>
        <!-- 法规层级 -->
        <regulations-hierarchy
          ref="regulations"
          @getSearchLists="getSearchLists"
          @updateChangeFilter="updateChangeFilter"
        ></regulations-hierarchy>
        <!-- 搜索框 -->
        <SearchBox
          v-show="
            lists.length !== 0 ||
              this.tagid !== '' ||
              this.potence !== '' ||
              (this.stime !== '' && this.etime !== '') ||
              this.searchText !== ''
          "
          ref="searchBox"
          @searchKeyWord="searchKeyWord"
          @selectTime="selectTime"
          @clearTime="clearTime"
          :folderid="folderid"
          :newSearchText="newSearchText"
          @changePotence="changePotence"
        ></SearchBox>
        <!-- 搜索导航 -->
        <div v-if="classifyresult.length !== 0" class="classify-nav-box">
          <div
            v-for="(item, index) in classifyresult"
            :key="index"
            class="classify-nav-item"
          >
            <span class="classify-nav-content">
              {{ item }}
            </span>
            <!-- <span class="sanjiao"></span> -->
          </div>
        </div>
        <!-- 提示语 -->
        <div v-show="!lists.length">
          <van-notice-bar wrapable :scrollable="false">
            <h4>特别提示</h4>
            <p v-if="isWX=='1'">
              请及时关注微信公众号“众智云擎税法检索”,
              即时精准获取税法文件智能推送。
            </p>
            <p v-else>
              请及时关注微信公众号“众智云擎税法检索”, 点击“云擎中心”按钮进入“文件提醒”, 即时精准获取税法文件智能推送。
            </p>
          </van-notice-bar>
          <p v-if="totalLists == 0 && chooseDir !== '全部文件夹'" style="padding-top: 15px; text-align: center; color: #a6a6a6">当前文件夹下没有您要检索的文件</p>
          <p style="padding-top: 15px; text-align: center">
            <img :src="gzhewm" alt="" style="width: 146px" />
          </p>
        </div>
        <!-- 文件夹弹框8989 -->
        <van-popup
          v-model="showSearchPopup"
          closeable
          position="bottom"
          :style="{ height: '70%', width: '100%' }"
        >
          <div class="selectNavS">
            <div :style="{
                color: '#000000',
                fontSize: '17px',
                textAlign: 'center',
                fontWeight: 'bold'
              }">上传文件库</div>
            <div class="title-wapper">
              <div class="notice-wapper">
              <van-image width="16" height="16" :src="noticeImg"/>
              <div class="check-file">选择文件夹即可查阅文件 </div>
              <!-- <van-notice-bar wrapable :scrollable="false">
                选择文件夹即可查阅文件
              </van-notice-bar> -->
            </div>
              <div>
                <span style="color: #69707C">使用数量：</span>
                <span style="color: #0084FF">{{usedDocNums}}/{{filePermission}}</span>
              </div>
            </div>
            
            
            <div class="marginStyleWapper">
              <div class="file-list-wapper">
                <div class="file-list-total">
                  <van-icon name="arrow-left" size="18" @click="onClickLeft" />
                  <span>{{docFolidName}}</span>
                </div>
                <template  v-if="docFolidName == '全部归档文件'">
                  <van-image  width="18" height="15" :src="fileIcon" @click="openBuild" />
                </template>
                <template  v-else>
                  <van-image  width="18" height="15" :src="fileIcon"
                  @click="openOprateItem"/>
                </template>
              </div>
              
              <!-- <van-nav-bar
                :title="docFolidName"
                left-text=""
                left-arrow
                @click-left="onClickLeft"
                id="resultTitle"
              >
                <template #right v-if="docFolidName == '全部归档文件'">
                  <van-icon name="ellipsis" size="18" color="#907456" @click="openBuild" />
                </template>
                <template #right v-else>
                  <van-icon name="ellipsis" size="18" color="#907456" @click="openOprateItem"/>
                </template>
              </van-nav-bar> -->


              <div class="marginStyle file">
                <div v-if="fixedDir.length > 0 && dirFlag">
                  <div
                    class="fileList"
                    v-for="dir in fixedDir"
                    :key="dir.dir_id"
                  >
                    <div @click="getDirLists(dir)">
                      <img src="../../assets/index/wenjianjia.png" />
                      <a>{{ dir.dir_name }} </a>
                    </div>
                  </div>
                </div>
                <div v-else>
                  <div v-if="fixedDirChild.length > 0">
                    <div
                      class="fileList"
                      v-for="dir in fixedDirChild"
                      :key="dir.dir_id"
                    >
                      <div @click="getDirLists(dir)">
                        <img src="../../assets/index/wenjianjia.png" />
                        <a>{{ dir.dir_name }}</a>
                      </div>
                    </div>
                  </div>
                  <div v-else class="noDir">暂无子文件夹</div>
                </div>
              </div>
              <van-button
                class="sureBtn"
                type="info"
                block
                @click="closePopup"
                >确定</van-button>
            </div>
          </div>
        </van-popup>
        <!-- 操作文件夹popup -->
        <van-popup
          v-model="showBlock"
          class="build-block"
          position="bottom">
          <div class="a-item" @click="showBuildDialogMethod(0)">新建子文件夹</div>
          <div class="a-cancel" @click="showBlock = false">取消</div>
        </van-popup>
        <!-- 操作文件夹popup -->
        <van-popup
          class="build-block-item"
          v-model="showItemBlock"
          position="bottom">
          <div class="a-item" @click="showBuildDialogMethod(1)">新建子文件夹</div>
          <template v-if="!preFolder.is_fixed">
            <div class="a-item" @click="removeMethod">删除文件夹</div>
            <div class="a-item" @click="showMoveDialogMethod">移动文件夹</div>
          </template>
          <div class="a-item-rename" @click="showRenameDialogMethod">重命名文件夹</div>
          <div class="a-cancel" @click="showItemBlock = false">取消</div>
        </van-popup>
        <!-- 新建文件夹dialog -->
        <van-dialog  v-model="showBuildDialog" title="新建文件夹" show-cancel-button  confirmButtonColor="#ed6a0c" @cancel="cancelCreate" @confirm="sureCreateFile">
          <van-field class="new-file-field" v-model="newFile" maxlength="12" placeholder="请输入文件夹名" />
        </van-dialog>
        <!-- 重命名文件夹dialog -->
        <van-dialog  v-model="showRenameDialog" title="重命名文件夹" show-cancel-button confirmButtonColor="#ed6a0c" @cancel="cancelRename" @confirm="sureRenameFile">
          <van-field class="new-file-field" v-model="rename" maxlength="12" placeholder="请输入文件夹名" />
        </van-dialog>

        <!-- 移动文件夹dialog -->
        <van-popup
          v-model="showMoveDialog"
          class="move-block"
          position="bottom"
          :style="{ height: '55%' }">
          <div class="move-btn-wapper">
            <van-button class="cancel-btn" size="small" @click="cancelMove">取消</van-button>
            <van-button v-if="canMove" size="small" class="move-btn" type="info" @click="move">移动</van-button>
            <van-button v-else class="move-btn" size="small" type="info" disabled>移动</van-button>
          </div>
          <div class="move-block-title">
            <van-icon name="arrow-left" color="#cb9728" @click="returnChoose" />
            <span>移动到 {{movedName}}</span>
          </div>
          <div v-if="showMoveFlag" class="move-block-content">
            <div class="move-block-item" v-for="(it, i) in moveFile" :key="i" @click="getDirNext(it)">
              <img src="../../assets/index/wenjianjia.png" />
              <span>{{it.dir_name}}</span>
            </div>
          </div>
          <div v-if="!showMoveFlag" class="move-block-item-no">暂无子文件夹</div>
          
        </van-popup>
        <!-- TODO:文件夹新功能 -->
        <!-- 文件夹操作组件 -->
        <doc-folid-operate
          :docFolidOperateShow.sync="docFolidOperateShow"
          :docFolidInfo="docFolidInfo"
        ></doc-folid-operate>

        <!-- 列表组件 -->
        <list-content
          ref="listCont"
          :lists="lists"
          :total="total"
        ></list-content>
      </div>
      <div style="height: 0.001rem"></div>
      <!-- 分页 -->
      <div v-if="lists.length > 0" class="pageBoxStyle">
        <Pagination
          :currentPage="currentPage"
          :total="total"
          :totalLists="totalLists"
          @prevPage="prevPage"
          @nextPage="nextPage"
          @jumpToPageSize="jumpToPageSize"
        ></Pagination>
      </div>
      <!-- 底部导航 -->
      <tabbar
        @alertBars="alertBars"
        @alertCengji="alertCengji"
        @updateOrDelete="updateOrDelete"
        @chooseUpdateOrDelete="chooseUpdateOrDelete"
        :selectedID="selectedId"
        :delSuccess="delSuccess"
      ></tabbar>
    </div>
    <!-- <div v-else class="noDatas">请先登录</div> -->

    <!-- 点击一键删除弹出框 -->
    <van-action-sheet
      v-model="showActiveSheet"
      get-container="body"
    >
    <div class="showActiveSheetContent">
      <div class="item item-line" @click="onSelect(0)">删除此文件夹下的所有文件</div>
      <div class="item item-line" @click="onSelect(1)">删除全文废止（失效）文件</div>
      <div class="item item-cancel" @click="onCancel">取消</div>
    </div>
      <!-- <div style="height: 210px">
        <van-divider
          :style="{
            fontSize: '17px',
            marginTop: '40px',
            marginBottom: '8px',
            position: 'relative',
          }"
        >
          请选择
          <van-icon
            class="closeIcon"
            @click="onCancel"
            name="close"
            color="#c8c9cc"
          />
        </van-divider>
        
        <div class="showActiveSheetContent">
          <button
            v-for="(act, index) in actions"
            :key="index"
            class="item item-line"
            @click="onSelect(index)"
          >
            <img class="img" :src="act.img" />
            <span class="word">{{ act.name }}</span>
          </button>
          <van-button block type="primary" color="#907456" @click="onCancel">
            取消
          </van-button>
        </div>
      </div> -->
    </van-action-sheet>
    <van-overlay :showLoding.sync="showLoding"></van-overlay>
  </div>
</template>

<script>
import SearchBox from "@/components/common/search";
import Tabbar from "@/components/common/tabbar";

import ClassificationRules from "@/components/common/classificationRules"; // 法规分类
import RegulationsHierarchy from "@/components/common/regulationsHierarchy"; // 法规层级
import ListContent from "@/components/common/listContent";
import VanOverlay from "@/components/common/vanOverlay";
import Pagination from "@/components/common/pagination"; // 分页
import DocFolidOperate from "@/components/newcommon/docfolid";
import { sortclassify } from "@/utils/newLibs/sortclassify";
import { commonToast } from "@/utils/lib/toast.js";

export default {
  data() {
    return {
      // 公众号二维码
      gzhewm: require("../../assets/indexImg/gzhewm.jpg"),
      showActiveSheet: false, // 点击一键删除弹出框
      actions: [
        {
          name: "删除此文件夹下的所有文件",
          img: require("../../assets/index/d1.png"),
        },
        {
          name: "删除全文废止（失效）文件",
          img: require("../../assets/index/d2.png"),
        },
      ],
      showLoding: false,
      selectedId: "c",
      chooseDir: "全部文件夹",
      lists: [],
      data: {
        classifytag: [],
        minlock: 0,
      },
      classifytag: [],
      flag: false,
      minback: 0,
      minlock: 0,
      currentPage: 1,
      total: 0,
      totalLists: 0,
      stime: "", // 开始时间
      etime: "", // 结束时间
      searchText: "", // 搜索关键字
      tagid: "",
      showSearchPopup: false, // 选择文件夹弹框
      // fixedDir: [], // 固定文件夹
      breadList: [],
      folderid: "", // 点击的文件夹的id
      tagpc: [],
      t1: [],
      t2: [],
      t3: [],
      proAndCityData: {},
      docFolidName: "全部归档文件",
      SearchTimes: 1,
      isFilter: false,
      clickConfirmBtn: true,
      showAllTagpc: [],
      deleteAll: false,
      delListtotal: 0,
      // 文件夹操作弹框
      docFolidOperateShow: false,
      docFolidInfo: {}, // 文件夹信息
      potence: "",
      classifyresult: [],
      changeFilter: false,
      // 新增(文件夹new)
      usedDocNums: 0, // 已经创建过的文件夹数量
      filePermission: 0, // 文件夹创建的最大数量
      showBlock: false, // 是否展示新建文件夹操作框
      showItemBlock: false, // 是否展示新建/重命名文件夹操作框
      dirFlag: true, // 显示固定文件夹和子文件夹的标杆
      currentFolder: [], // 当前文件夹children(下方展示)
      preFolder: [], // 当前文件夹(箭头后展示)
      folderPath: [], // 浏览文件路径
      fixedDir: [], // 固定文件夹列表
      fixedDirChild: [], // 固定子文件夹
      moveFile: [], // 转移文件夹当前显示
      fPath: [], // 转移文件夹路径
      showBuildDialog: false, // 是否展示全部文件下的dialog
      newFile: '', // 新建文件夹名
      curParentDirId: '', // 当前选中文件夹的父级id
      showRenameDialog: false, // 是否展示重命名dialog
      rename: '', // 重命名文件名
      showMoveDialog: false, // 是否展示移动dialog
      movedName: '', // 移动到的文件夹名
      showMoveFlag: true, // 移动flag
      canMove: true, // 是否能够移动
      movedId: '', // 要移动到的文件夹下id
      isWX: Number(localStorage.getItem("WX_VERSION")),
      noticeImg: require("../../assets/index/tishi.png"),
      fileIcon: require("../../assets/index/icon_file.png"),
      delSuccess: false //删除成功标志
    };
  },
  created() {
    //console.log('smartcloud created--->')
    this.getAllDocs()
    this.filePermission = this.$store.state.user.permission.filter(a => a.f == '000012')[0].n
    this.$nextTick(() => {
      let dom = document.getElementById("goToHere1");
      dom.scrollIntoView();
    })
  },
  components: {
    SearchBox,
    Tabbar,
    ClassificationRules,
    RegulationsHierarchy,
    ListContent,
    VanOverlay,
    Pagination,
    DocFolidOperate,
  },
  computed: {
    wxgenerateid() {
      return this.$store.state.user.wxgenerateid;
    },
    userId() {
      return this.$store.state.user.userId;
    },
    phone() {
      return this.$store.state.user.mobileNum;
    },
    wxunionid() {
      return sessionStorage.getItem("wxunionid");
    },
    newSearchText() {
      // 切换全国版 true 与地方版false
      return this.$store.state.changeSomeThing.newSearchText;
    }
  },
  methods: {
    // 转移文件夹-列表显示
    getDirNext (e) {
      if (!this.canMove) {
        this.$toast('不能转移到自身以及自身子夹')
        return
      }
      if (e.dir_id == this.preFolder.dir_id) {
        this.canMove = false
      }
      if (e.children.length >= 0) {
        this.moveFile = e.children
        this.fPath.push(e)
        this.movedName = e.dir_name
        this.movedId = e.dir_id
      }
      if (e.children.length == 0) {
        this.showMoveFlag = false
      }
    },
    // 移动request
    moveRequest () {
      this.$http.reqMoveDoc({
        dir_id: this.preFolder.dir_id,
        new_parent_dir_id: this.movedId
      }).then((response) => {
        this.$toast.success('移动成功')
        this.returnChoose()
        const len = this.folderPath.length
        if (len > 1) {
          const floder = this.folderPath[len - 2]
          this.docFolidName = floder.dir_name
          this.chooseDir = floder.dir_name
          this.fixedDirChild = floder.children.filter(item => item.dir_id != this.preFolder.dir_id)
        } else {
          this.chooseDir = '全部文件夹'
          this.docFolidName = '全部归档文件'
          this.fixedDirChild = []
        }
        this.preFolder = []
        this.moveLeft()
        this.getAllDocs()
        this.showMoveDialog = false
      })
    },
    // 点击移动
    move () {
      if (this.movedName == '') {
        this.$notify({
          duration: 5000,
          type: 'warning',
          message: '您还未选择文件夹!'
        })
        return false
      }
      // console.log('888***', this.preFolder)
      if (this.preFolder.children && this.preFolder.children.length > 0) {
        this.$dialog.confirm({
          message: '此文件夹下含有子文件夹，确认一并移动吗?',
        })
        .then(() => {
          this.moveRequest()
        })
        .catch(() => {
           this.$http.reqGetAllDocs({}).then((response) => {
            if (response.rtncode === 1) {
              if(response.rltcode === 1) {
                const data = response.data.tree
                data.dir_name = '全部归档文件'
                this.showMoveFlag = true
                this.movedName = ''
                this.fPath = []
                this.fPath.push(data)
                this.moveFile = []
                this.moveFile = data.children
              }
            }
          })
          this.showMoveDialog = false
        })
      } else {
        this.moveRequest()
      }
    },
    // 点击取消移动
    cancelMove () {
      this.showMoveDialog = false
    },
    // 转移文件夹-返回选择
    returnChoose () {
      this.showMoveFlag = true
      this.canMove = true
      let len = this.fPath.length
      let fObj = {}
      if (len > 1) {
        this.fPath.pop()
        fObj = this.fPath[len - 2].children
        this.movedName = this.fPath[len - 2].dir_name
        this.movedId = this.fPath[len - 2].dir_id
        //console.log('zzzz1', this.fPath[len - 2])
      } else {
        fObj = this.fPath[len - 1].children
        this.movedName = this.fPath[len - 1].dir_name
        this.movedId = this.fPath[len - 1].dir_id
      }
      if (this.movedName === '全部归档文件') {
        this.movedName = ''
      }
      this.moveFile = fObj
    },
    // open移动文件夹dialog
    showMoveDialogMethod () {
      this.showMoveDialog = true
      this.showItemBlock = false
    },
    
    // 取消重命名
    cancelRename () {
      this.rename = ''
    },
    // 确认重命名文件夹
    sureRenameFile () {
      this.showItemBlock = false
      this.$http.reqRenameDoc({
        dir_id: this.folderid,
        new_dir_name: this.rename,
      }).then((response) => {
        if (response.rtncode === 1) {
          if (response.rltcode === 1) {
            // 父级文件改名
            const len = this.folderPath.length
            if (len > 1) {
              let path = this.folderPath[len - 2]
              this.folderPath[len - 2].children = path.children.map(item => {
                if (item.dir_id == this.folderid) {
                  return {
                    ...item,
                    dir_name: this.rename
                  }
                }
                return item
              })
            }
            // 当前文件夹改名
            this.preFolder.dir_name = this.rename
            this.docFolidName = this.rename
            this.chooseDir = this.rename
            this.rename = ''
          } else {
            this.$notify({
              duration: 5000,
              type: 'warning',
              message: response.rltdesc
            })
            this.rename = ''
          }
        } else {
          this.$notify({
            duration: 5000,
            type: 'warning',
            message: response.rtndesc
          })
          this.rename = ''
        }
      })
      .catch((err) => {
        console.log('333#', err)
      })
    },
    // 打开重命名dialog
    showRenameDialogMethod () {
      this.showRenameDialog = true
      this.showItemBlock = false
    },
    // 打开删除文件夹dialog
    removeMethod () {
      this.showItemBlock = false
      //console.log('pre', this.preFolder)
      if(this.preFolder.children.length > 0) {
        this.$dialog.confirm({
          message: '此文件夹下含有其他文件夹,确认一并删除吗?',
        }).then(() => {
          this.$http.reqRemoveDoc({
            dir_id: this.folderid
          }).then((response) => {
            if (response.rtncode === 1) {
              if (response.rltcode === 1) {
                this.$toast.success('删除成功')
                const len = this.folderPath.length
                if(len > 1) {
                  const path = this.folderPath[len - 2]
                  this.folderPath[len - 2].children = path.children.filter(item=> {
                    return item.dir_id != this.folderid
                  })
                }
                this.onClickLeft()
                this.getAllDocs()
              } else {
                this.$notify({
                  duration: 5000,
                  type: 'warning',
                  message: response.rltdesc
                })
              }
            } else {
              this.$notify({
                duration: 5000,
                type: 'warning',
                message: response.rtndesc
              })
            }
          })
        })
      } else {
        this.$http.reqRemoveDoc({
          dir_id: this.folderid
        }).then((response) => {
          if (response.rtncode === 1) {
            if (response.rltcode === 1) {
              this.$toast.success('删除成功')
              const len = this.folderPath.length
              if (len > 1) {
                const path = this.folderPath[len - 2]
                this.folderPath[len - 2].children = path.children.filter(item=> {
                  return item.dir_id != this.folderid
                })
              }
              this.onClickLeft()
              this.getAllDocs()
            }
          }
        })
      }
    },
    // 取消创建文件夹
    cancelCreate () {
      this.newFile = ''
    },
    // 确认创建文件夹
    sureCreateFile () {
      if (!this.newFile) {
        this.$notify({
          duration: 5000,
          type: 'warning',
          message: '文件夹名不能为空'
        })
        return false
      }
      if (this.usedDocNums > this.filePermission) {
        this.$notify({
          duration: 5000,
          type: 'warning',
          message: '已超过文件夹所限制的最大数量!'
        })
        return false
      }
      this.$http.reqCreateNewDoc({
        parent_dir_id: this.curParentDirId,
        dir_name: this.newFile,
        is_root: false,
        is_fixed: false
      }).then((response) => {
        if (response.rtncode === 1) {
          if (response.rltcode === 1) {
            const data = response.data
            this.currentFolder.push({
              children: [],
              dir_id: data.dirid,
              dir_name: data.dir_name,
              is_fixed: data.isfixed,
              is_root: data.isroot,
              parent_dir_id: data.parent_dir_id
            })
            this.newFile = ''

            this.$http.reqGetAllDocs({}).then((response) => {
              if (response.rtncode === 1) {
                if(response.rltcode === 1) {
                  const data = response.data.tree
                  // 已经创建了的文件夹数量
                  this.usedDocNums = response.data.numberoffolders
                  console.log('456tree', response.data)
                }
              }
            })
          } else {
            this.$notify({
              duration: 5000,
              type: 'warning',
              message: response.rltdesc
            })
            this.newFile = ''
          }
        } else {
          this.$notify({
            duration: 5000,
            type: 'warning',
            message: response.rtndesc
          })
          this.newFile = ''
        }
      })
    },
    // 打开新建子文件夹操作框
    openBuild () {
      this.showBlock = true
    },
    openOprateItem () {
      this.showItemBlock = true
    },
    showBuildDialogMethod (e) {
      if (e == 0) {
        this.curParentDirId = this.fixedDir[0].parent_dir_id
      } else {
        this.curParentDirId = this.folderid
      }
      this.showBuildDialog = true
      this.showBlock = false
      this.showItemBlock = false
    },
    // 获取所有文件夹目录
    getAllDocs () {
      this.$http.reqGetAllDocs({}).then((response) => {
        if (response.rtncode === 1) {
          if(response.rltcode === 1) {
            const data = response.data.tree
            data.dir_name = '全部归档文件'
            // 获取旧文件路径 
            const oldFp = Object.assign([], this.folderPath)
            this.folderPath = []
            this.folderPath.push(data)
            if (oldFp.length > 1) {
              let nextData = Object.assign({}, data)
              // 将移动的文件放到文件路径下
              for(let i = 1; i <= oldFp.length - 1; i++) {
                let nFloder = nextData.children.find(item => item.dir_id == oldFp[i].dir_id)
                nextData = nFloder
                if (nFloder) {
                  this.folderPath.push(nFloder)
                  if (i == oldFp.length - 1) {
                    this.currentFolder = nFloder.children
                  }
                }
              }
            } else {
              this.currentFolder = data.children
            }
            this.fPath = []
            this.fPath.push(data)
            this.fixedDir = []
            this.fixedDir = data.children
            this.moveFile = []
            this.moveFile = data.children
            // 已经创建了的文件夹数量
            this.usedDocNums = response.data.numberoffolders
            console.log('123tree', response.data)
          }
        }
      })
    },
    alertPopup() {
      this.showSearchPopup = true;
    },
    clearClassData() {
      this.$refs.classification.alertBar2();
    },
    // move移动时点击左侧返回
    moveLeft () {
      const len = this.folderPath.length
      let folder = {}
      if (len > 1) {
        this.folderPath.pop()
        folder = this.folderPath[len - 2]
      } else {
        this.dirFlag = true
        folder = this.folderPath[len - 1]
      }
      // 新加
      this.folderid = folder.dir_id;
      this.getData(this.tagid, this.stime, this.etime, this.searchText);
    },
    // 点击左侧的返回按钮
    onClickLeft() {
      const len = this.folderPath.length
      let folder = {}
      if (len > 1) {
        this.folderPath.pop()
        folder = this.folderPath[len - 2]
      } else {
        this.dirFlag = true
        folder = this.folderPath[len - 1]
      }
      this.preFolder = folder
      this.currentFolder = folder.children
      if (folder.dir_name === '全部归档文件') {
        this.chooseDir = '全部文件夹'
      } else {
        this.chooseDir = folder.dir_name
      }
      this.docFolidName = folder.dir_name
      this.fixedDirChild =  folder.children
      // 新加end
      this.clickConfirmBtn = true;
      this.isFilter = false;
      this.deleteAll = false;

      this.classifyresult = [];
      // 初始化法规分类弹框的数据
      this.data = {
        classifytag: [],
        minlock: 0,
      };

      this.$refs.searchBox.keyword = "";
      this.$refs.searchBox.startAndEndTimeOne = "";
      this.$refs.searchBox.startAndEndTimeTwo = "";
      this.$refs.searchBox.clearPotence();

      this.stime = "";
      this.etime = "";
      this.searchText = "";
      this.potence = "";
      this.tagid = "";

      if (this.data.classifytag.length === 0 && this.data.minlock === 0) {
        this.$refs.classification.alertBar2();
      }
      // 新加
      this.folderid = folder.dir_id;
      this.getData(this.tagid, this.stime, this.etime, this.searchText);
      //新加end
    },
    // 获取子文件夹
    getDirLists(dir) {
      if (this.preFolder) {
        const data = this.currentFolder.find(item => item.dir_id == dir.dir_id)
        if (data && data.children) {
          this.folderPath.push(data)
          this.currentFolder = data.children
          this.preFolder = data
          this.fixedDirChild = data.children
        } else {
          this.fixedDirChild = []
        }
      }
      
      // console.log("点击固定文件夹的哪一个==》", dir);
      this.dirFlag = false;
      this.SearchTimes = 1;
      this.docFolidName = dir.dir_name;

      this.chooseDir = dir.dir_name;

      this.folderid = dir.dir_id;
      this.$refs.searchBox.keyword = "";
      this.$refs.searchBox.startAndEndTimeOne = "";
      this.$refs.searchBox.startAndEndTimeTwo = "";
      this.$refs.searchBox.clearPotence();
      this.$refs.classification.clearTagId();

      this.stime = "";
      this.etime = "";
      this.searchText = "";
      this.potence = "";
      this.tagid = "";

      // 清除数据
      this.backStatus();
      this.$refs.listCont.toggle([]);

      let args = {
        sdirid: dir.dir_id,
      };
      
      this.getData(this.tagid, this.stime, this.etime, this.searchText);
    },
    // 获取云端文件
    getData(tagid, stime, etime, text) {
      this.showLoding = true;
      let args = {
        searchtimes: this.SearchTimes, // 查询次数，第一次查询一定传1，二次查询传2
        frist: {
          text:
            this.searchText && this.searchText !== "" ? this.searchText : "",
          potence: this.potence !== "" ? this.potence : "",
          icode: "",
          tcode: "",
          kcode: "",
          country: "",
          ps: {
            p: "",
            c: "",
          },
          dirid: this.folderid, // 上传目录ID，云端查询需要这个参数
          id: this.tagid && this.tagid !== "" ? this.tagid : "",
          stime: this.stime && this.stime !== "" ? this.stime : "",
          etime: this.etime && this.etime !== "" ? this.etime : "",
        },
        second: [],
        fliter: {
          isfilter: this.isFilter,
          tagpc: this.tagpc,
          tagid: "",
        },
        pager: [
          {
            pagesize: 10, // 当前页
            pageindex: this.currentPage, // 每页显示的条数
          },
        ],
      };
      this.$http
        .reqGetUploadFiles(args)
        .then((response) => {
          if (response.rtncode === 1) {
            if (response.rltcode === 1) {
              //console.log("获取云端文件==============>>>>>11", response);

              if (
                response.tbls[0].items === null &&
                response.tbls[0].classifytag.length === 0
              ) {
                this.$refs.classification.alertBar2();
              }

              this.showLoding = false;
              this.lists =
                response.tbls[0].items !== null ? response.tbls[0].items : [];

              this.t1 =
                response.tbls[0].divisiontag.length !== 0 &&
                response.tbls[0].divisiontag.t1.length > 0
                  ? response.tbls[0].divisiontag.t1
                  : [];
              this.t2 =
                response.tbls[0].divisiontag.length !== 0 &&
                response.tbls[0].divisiontag.t2.length > 0
                  ? response.tbls[0].divisiontag.t2
                  : [];
              this.t3 =
                response.tbls[0].divisiontag.length !== 0 &&
                response.tbls[0].divisiontag.t3.length > 0
                  ? response.tbls[0].divisiontag.t3
                  : [];
              this.proAndCityData = {
                t1: this.t1.length > 0 ? this.t1 : [],
                t2: this.t2.length > 0 ? this.t2 : [],
                t3: this.t3.length > 0 ? this.t3 : [],
              };
              if (this.clickConfirmBtn) {
                this.tagpc = this.filterData(this.proAndCityData);
                this.showAllTagpc = [];
                this.showAllTagpc = this.tagpc;
              }

              this.totalLists = response.tbls[0].total; // 总的条数

              this.total = Math.ceil(this.totalLists / 10);

              if (this.currentPage > this.total) {
                this.currentPage = this.total || 1;
              }

              // this.classifytag = response.tbls[0].classifytag;
              // this.minback = response.tbls[0].minback;
              // this.minlock = response.tbls[0].minlock;
              this.flag = true;
              // this.data = {
              //   classifytag: this.classifytag,
              //   minlock: this.minlock ? this.minlock : 0,
              // };

              this.$store.commit(
                "search/setIsProtect",
                response.tbls[0].protect
              );
              this.$store.commit(
                "search/setWarningLevel",
                response.tbls[0].warninglevel
              );
              this.$store.commit(
                "search/setWarningText",
                response.tbls[0].warningtext
              );

              this.$store.dispatch("choose/updateLists", this.lists);
              // this.bus.$emit("classifytagData", this.data);
              if (
                response.tbls[0].items == null &&
                (this.tagid !== "" ||
                  (this.stime !== "" && this.etime !== "") ||
                  this.searchText !== "" ||
                  this.potence !== "")
              ) {
                commonToast("当前文件夹下没有您要检索的文件", this);
              }
            } else {
              warningNotify(response.rltdesc, this);
              this.showLoding = false;
            }
          } else {
            warningNotify(response.rtndesc, this);
            this.showLoding = false;
          }
        })
        .catch(() => {
          this.showLoding = false;
        });
    },
    getTree(data) {
      console.log("getTree START");
      this.showLoding = true;
      let args = {
        searchtimes: 1, // 查询次数，第一次查询一定传1，二次查询传2
        frist: {
          text: "",
          potence: "1",
          icode: "",
          tcode: "",
          kcode: "",
          country: "",
          ps: {
            p: this.$store.state.commonSearchData.valueProvCode,
            c: this.$store.state.commonSearchData.valueCityCode,
          },
          dirid: "", // 上传目录ID，云端查询需要这个参数
          id: data.tagid !== undefined ? data.tagid : "",
          stime: "",
          etime: "",
        },
        second: [],
        fliter: {
          isfilter: false,
          tagpc: this.tagpc,
          tagid: "",
        },
        pager: [
          {
            pagesize: 10, // 当前页
            pageindex: this.currentPage, // 每页显示的条数
          },
        ],
      };
      
      this.$http
        .reqGetGeneralFiles(args)
        .then((response) => {
          console.log("获取云端tree文件==============>>>>>", response);

          if (
            response.tbls[0].items === null &&
            response.tbls[0].classifytag.length === 0
          ) {
            this.$refs.classification.alertBar2();
          }

          this.showLoding = false;

          this.$refs.classification.cantclick = false;
          this.classifytag = response.tbls[0].classifytag;
          this.minback = response.tbls[0].minback;
          this.minlock = response.tbls[0].minlock;
          this.flag = true;
          this.data = {
            classifytag: this.classifytag,
            minlock: this.minlock ? this.minlock : 0,
          };
          this.bus.$emit("classifytagData", this.data);
        })
        .catch(() => {
          this.showLoding = false;
        });
    },
    // 获取云端文件
    backNav(tagid, stime, etime, text) {
      this.showLoding = true;
      let args = {
        searchtimes: this.SearchTimes, // 查询次数，第一次查询一定传1，二次查询传2
        frist: {
          text:
            this.searchText && this.searchText !== "" ? this.searchText : "",
          potence: this.potence !== "" ? this.potence : "",
          icode: "",
          tcode: "",
          kcode: "",
          country: "",
          ps: {
            p: "",
            c: "",
          },
          dirid: this.folderid, // 上传目录ID，云端查询需要这个参数
          id: this.tagid && this.tagid !== "" ? this.tagid : "",
          stime: this.stime && this.stime !== "" ? this.stime : "",
          etime: this.etime && this.etime !== "" ? this.etime : "",
        },
        second: [],
        fliter: {
          isfilter: this.isFilter,
          tagpc: this.tagpc,
          tagid: "",
        },
        pager: [
          {
            pagesize: 10, // 当前页
            pageindex: this.currentPage, // 每页显示的条数
          },
        ],
      };
      this.$http
        .reqGetUploadFiles(args)
        .then((response) => {
          if (response.rtncode === 1) {
            if (response.rltcode === 1) {
              console.log("获取云端文件==============>>>>>", response);

              if (
                response.tbls[0].items === null &&
                response.tbls[0].classifytag.length === 0
              ) {
                this.$refs.classification.alertBar2();
              }

              this.showLoding = false;
              this.lists =
                response.tbls[0].items !== null ? response.tbls[0].items : [];

              this.t1 =
                response.tbls[0].divisiontag.length !== 0 &&
                response.tbls[0].divisiontag.t1.length > 0
                  ? response.tbls[0].divisiontag.t1
                  : [];
              this.t2 =
                response.tbls[0].divisiontag.length !== 0 &&
                response.tbls[0].divisiontag.t2.length > 0
                  ? response.tbls[0].divisiontag.t2
                  : [];
              this.t3 =
                response.tbls[0].divisiontag.length !== 0 &&
                response.tbls[0].divisiontag.t3.length > 0
                  ? response.tbls[0].divisiontag.t3
                  : [];
              this.proAndCityData = {
                t1: this.t1.length > 0 ? this.t1 : [],
                t2: this.t2.length > 0 ? this.t2 : [],
                t3: this.t3.length > 0 ? this.t3 : [],
              };
              if (this.clickConfirmBtn) {
                this.tagpc = this.filterData(this.proAndCityData);
                this.showAllTagpc = [];
                this.showAllTagpc = this.tagpc;
              }

              this.totalLists = response.tbls[0].total; // 总的条数

              this.total = Math.ceil(this.totalLists / 10);

              if (this.currentPage > this.total) {
                this.currentPage = this.total || 1;
              }

              this.classifytag = response.tbls[0].classifytag;
              this.minback = response.tbls[0].minback;
              this.minlock = response.tbls[0].minlock;
              this.flag = true;
              this.data = {
                classifytag: this.classifytag,
                minlock: this.minlock ? this.minlock : 0,
              };

              this.$store.commit(
                "search/setIsProtect",
                response.tbls[0].protect
              );
              this.$store.commit(
                "search/setWarningLevel",
                response.tbls[0].warninglevel
              );
              this.$store.commit(
                "search/setWarningText",
                response.tbls[0].warningtext
              );

              this.$store.dispatch("choose/updateLists", this.lists);
              this.bus.$emit("classifytagData", this.data);
              if (
                response.tbls[0].items === null &&
                (this.tagid !== "" ||
                  (this.stime !== "" && this.etime !== "") ||
                  this.searchText !== "")
              ) {
                commonToast("当前文件夹下没有您要检索的分类文件", this);
              }
            } else {
              warningNotify(response.rltdesc, this);
              this.showLoding = false;
            }
          } else {
            warningNotify(response.rtndesc, this);
            this.showLoding = false;
          }
        })
        .catch(() => {
          this.showLoding = false;
        });
    },
    // 第一次改变tagid的时候 循环城市数据 tagpc
    filterData(data) {
      let searchParameter = [];
      let national = [];
      let tagpc1 = [];
      let tagpc2 = [];
      if (data.t1.length > 0) {
        national = [{ p: "000000", c: "000000" }];
      }
      if (data.t2.length > 0) {
        // 循环省份
        data.t2.forEach((item) => {
          let stringlength = item.id.length;
          let pstring = item.id.substring(0, 6); // 截取前六位
          let nstring = item.id.substring(stringlength - 6, stringlength); // 截取后六位
          tagpc1.push({ p: pstring, c: nstring });
        });
      }
      if (data.t3.length > 0) {
        // 循环城市
        data.t3.forEach((item) => {
          if (item.children && item.children.length > 0) {
            item.children.forEach((item1) => {
              let stringlength = item1.id.length;
              let pstring = item1.id.substring(0, 6); // 截取前六位
              let nstring = item1.id.substring(stringlength - 6, stringlength); // 截取后六位
              tagpc2.push({ p: pstring, c: nstring });
            });
          }
        });
      }
      searchParameter = [...national, ...tagpc1, ...tagpc2];
      return searchParameter;
    },
    // 清除数据
    clearData() {
      // this.$refs.searchBox.keyword = "";
      // this.$refs.searchBox.startAndEndTimeOne = "";
      // this.$refs.searchBox.startAndEndTimeTwo = "";
      // this.tagid = "";
      // this.stime = "";
      // this.etime = "";
      // this.searchText = "";
      this.lists = [];
      this.tagpc = [];
      this.dirFlag = true;
      this.fixedDirChild = [];
      this.currentPage = 1;
      this.flag = false;
      this.folderid = "";
    },
    // 选择省份城市后触发的事件
    getSearchLists(tagpc) {
      // console.log('传递给父组件的数据tagpc==》', tagpc)
      // console.log('传递给父组件的数据this.showAllTagpc==》', this.showAllTagpc)
      this.clickConfirmBtn = false;
      this.isFilter = true;
      this.tagpc = tagpc;
      console.log("this.tagpc", this.tagpc);
      this.currentPage = 1;
      this.getData(this.tagid, this.stime, this.etime, this.searchText);
    },
    showGetData(data) {
      this.showData = data;
      this.tagid = data.tagid;
      this.isFilter = false;
      this.getData(this.tagid, data.stime, data.etime, data.searchText);
      // 清除数据
      this.backStatus();
      this.$refs.listCont.toggle([]);
    },
    showBackNav(data) {
      this.showData = data;
      this.tagid = data.tagid;
      this.isFilter = false;
      this.backNav();
      // 清除数据
      this.backStatus();
      this.$refs.listCont.toggle([]);
    },
    // 选择时间
    selectTime(time) {
      this.stime = time.stime;
      this.etime = time.etime;
      this.currentPage = 1;

      if (this.folderid) {
        this.SearchTimes = 1;
        this.isFilter = false;
        this.clickConfirmBtn = true;
        // this.tagid = "";
        // this.$refs.classification.minlock = 0;;
        this.getData(this.tagid, this.stime, this.etime, this.searchText);
      } else {
        this.$notify({
          color: "#fff",
          background: "#F27852",
          message: "请先选择文件夹",
          duration: 5000,
        });
      }

      // 清除数据
      this.backStatus();
      this.$refs.listCont.toggle([]);
    },
    // 搜索按钮
    searchKeyWord(keyword) {
      this.searchText = keyword;
      this.isFilter = false;
      this.clickConfirmBtn = true;
      // this.tagid = "";
      // this.$refs.classification.minlock = 0;;
      this.currentPage = 1;
      if (this.folderid) {
        // if (!(this.stime || this.etime || keyword)) {
        this.SearchTimes = 1;
        // } else {
        //   this.SearchTimes = 2;
        // }
        this.getData(this.tagid, this.stime, this.etime, this.searchText);
      } else {
        this.$notify({
          color: "#fff",
          background: "#F27852",
          message: "请先选择文件夹",
          duration: 5000,
        });
      }
      // 清除数据
      this.backStatus();
      this.$refs.listCont.toggle([]);
    },
    // 清除时间按钮
    clearTime() {
      this.isFilter = false;
      this.clickConfirmBtn = true;
      // this.tagid = "";
      // this.$refs.classification.minlock = 0;;
      this.stime = "";
      this.etime = "";
      this.currentPage = 1;
      if (this.folderid) {
        // if (!this.searchText) {
        this.SearchTimes = 1;
        // } else {
        //   this.SearchTimes = 2;
        // }
        this.getData(this.tagid, this.stime, this.etime, this.searchText);
      }
      // 清除数据
      this.backStatus();
      this.$refs.listCont.toggle([]);
    },
    // 改变tagid的值
    changeTagid(val) {
      this.tagid = val;
      this.backStatus();
      this.$refs.listCont.toggle([]);
    },
    // 改变页码
    changePage(num) {
      console.log("num==>>", num);
      this.currentPage = num;
      this.$nextTick(() => {
        let dom = document.getElementById("goToHere1");
        dom.scrollIntoView();
      });
      this.getData(this.tagid, this.stime, this.etime, this.searchText);
    },
    prevPage() {
      // 上一页
      if (this.currentPage == 1) return;
      this.currentPage--;
      this.$nextTick(() => {
        let dom = document.getElementById("goToHere1");
        dom.scrollIntoView();
      });
      this.getData(this.tagid, this.stime, this.etime, this.searchText);
    },
    nextPage() {
      // 下一页
      if (this.currentPage == this.total) return;
      this.currentPage++;
      this.$nextTick(() => {
        let dom = document.getElementById("goToHere1");
        dom.scrollIntoView();
      });
      this.getData(this.tagid, this.stime, this.etime, this.searchText);
    },
    jumpToPageSize(num) {
      // 跳转到多少页
      this.currentPage = num;
      this.getData(this.tagid, this.stime, this.etime, this.searchText);
    },
    // 点击弹出搜索导航框
    alertBars() {
      if (this.flag) {
        this.$refs.classification.alertBars();
      } else if (!this.flag) {
        this.$notify({
          color: "#fff",
          background: "#F27852",
          message: "请先选择文件夹",
          duration: 5000,
        });
      }
    },
    // 点击弹出法规层级框
    alertCengji() {
      // if (this.deleteAll) {
      //   this.$refs.regulations.clearData();
      // }
      if (this.flag && !this.deleteAll) {
        this.$refs.regulations.processData(this.proAndCityData);
      } else if (!this.flag) {
        this.$notify({
          color: "#fff",
          background: "#F27852",
          message: "请先选择文件夹",
          duration: 5000,
        });
      }
    },
    // 取消
    onCancel() {
      this.showActiveSheet = false;
    },
    // 点击了智慧云端一键删除
    onSelect(index) {
      if (index === 0) {
        // 删除当前文件夹下得所有文件
        if (this.lists.length > 0) {
          this.$dialog
            .confirm({
              title: "提示",
              message: `您确定删除此文件夹下的所有文件吗?`,
            })
            .then(() => {
              this.$http
                .reqRemoveFilesByFolderId(this.folderid)
                .then((response) => {
                  if (response.rtncode === 1) {
                    if (response.rltcode === 1) {
                      this.lists = [];
                      this.getData();
                      this.$refs.classification.alertBar2();
                      this.$notify({
                        color: "#fff",
                        background: "#F27852",
                        message: "删除成功",
                        duration: 5000,
                      });
                      this.backStatus();
                      this.deleteAll = true;
                      this.showActiveSheet = false;
                    }
                  }
                });
            })
            .catch(() => {
              // on cancel
            });
        } else {
          this.$notify({
            duration: 5000,
            color: "#fff",
            background: "#F27852",
            message: "当前文件夹下无文件",
          });
          this.showActiveSheet = false;
        }
      } else if (index === 1) {
        // 删除所有全文废止(失效)文件
        if (this.lists.length === 0) {
          this.$notify({
            duration: 5000,
            color: "#fff",
            background: "#F27852",
            message: "当前文件夹下无全文废止(失效)文件",
          });
          this.backStatus();
          this.showActiveSheet = false;
        } else {
          this.$dialog
            .confirm({
              title: "提示",
              message: `您确定删除此文件夹下的所有全文废止(失效)文件吗?`,
            })
            .then(() => {
              this.$http
                .reqRemoveAbolitionFilesByFolderId(this.folderid)
                .then((response) => {
                  if (response.rtncode === 1) {
                    if (response.rltcode === 1) {
                      if (
                        this.tagid ||
                        this.stime ||
                        this.etime ||
                        this.searchText
                      ) {
                        this.getData(
                          this.tagid,
                          this.stime,
                          this.etime,
                          this.searchText
                        );
                      } else {
                        this.getData();
                        this.$refs.classification.alertBar2();
                      }
                      this.$notify({
                        duration: 5000,
                        color: "#fff",
                        background: "#F27852",
                        message: "删除成功",
                      });
                      this.backStatus();
                      this.showActiveSheet = false;
                    }
                  }
                });
            })
            .catch(() => {
              // on cancel
            });
        }
      }
    },
    // 点击智慧云端的一键删除
    updateOrDelete() {
      if (!this.folderid) {
        this.$notify({
          duration: 5000,
          color: "#fff",
          background: "#F27852",
          message: "请先选择文件夹",
        });
        this.showActiveSheet = false;
      } else {
        this.showActiveSheet = true;
      }
    },
    // 删除所有文件
    deleteThisAllFiles() {
      if (this.lists.length > 0) {
        this.$dialog
          .confirm({
            title: "提示",
            message: `您确定删除此文件夹下的所有文件吗?`,
          })
          .then(() => {
            this.$http
              .reqRemoveFilesByFolderId(this.folderid)
              .then((response) => {
                if (response.rtncode === 1) {
                  if (response.rltcode === 1) {
                    this.lists = [];
                    this.getData();
                    this.$refs.classification.alertBar2();
                    this.showActiveSheet = false;
                    this.$notify({
                      duration: 5000,
                      color: "#fff",
                      background: "#F27852",
                      message: "删除成功",
                    });
                    this.backStatus();
                    this.deleteAll = true;
                  }
                }
              });
          })
          .catch(() => {
            // on cancel
          });
      } else {
        this.$notify({
          duration: 5000,
          color: "#fff",
          background: "#F27852",
          message: "当前文件夹下无文件",
        });
        this.showActiveSheet = false;
      }
    },
    // 删除全文废止(失效)文件
    deleteAbolish() {
      if (this.lists.length === 0) {
        this.$notify({
          duration: 5000,
          color: "#fff",
          background: "#F27852",
          message: "当前文件夹下无全文废止(失效)文件",
        });
        this.backStatus();
        this.showActiveSheet = false;
      } else {
        this.$dialog
          .confirm({
            title: "提示",
            message: `您确定删除此文件夹下的所有全文废止(失效)文件吗?`,
          })
          .then(() => {
            this.$http
              .reqRemoveAbolitionFilesByFolderId(this.folderid)
              .then((response) => {
                if (response.rtncode === 1) {
                  if (response.rltcode === 1) {
                    if (
                      this.tagid ||
                      this.stime ||
                      this.etime ||
                      this.searchText
                    ) {
                      this.getData(
                        this.tagid,
                        this.stime,
                        this.etime,
                        this.searchText
                      );
                    } else {
                      this.getData();
                      this.$refs.classification.alertBar2();
                    }
                    this.showActiveSheet = false;
                    this.$notify({
                      duration: 5000,
                      color: "#fff",
                      background: "#F27852",
                      message: "删除成功",
                    });
                    this.backStatus();
                  }
                }
              });
          })
          .catch(() => {
            // on cancel
          });
      }
    },
    // 点击智慧云端的选择删除
    chooseUpdateOrDelete() {
      this.delListtotal = 0;
      if (!this.folderid) {
        this.$notify({
          duration: 5000,
          color: "#fff",
          background: "#F27852",
          message: "请先选择文件夹",
        });
      } else {
        if (this.lists.length === 0) {
          this.$notify({
            duration: 3000,
            color: "#fff",
            background: "#F27852",
            message: "当前文件夹下无文件",
          });
          this.backStatus();
        } else if (
          this.$store.state.choose.flag3 === false &&
          this.$store.state.choose.lists.length > 0 &&
          this.$store.state.choose.result.length === 0
        ) {
          this.$refs.listCont.changeFlag();
          this.$store.commit("choose/setFlag3", true);
          this.$store.commit("choose/setDelWord", "确定");
          this.$notify({
            duration: 3000,
            color: "#fff",
            background: "#F27852",
            message: "请先选择要删除的文件",
          });
        } else if (
          this.$store.state.choose.flag3 === true &&
          this.$store.state.choose.lists.length > 0 &&
          this.$store.state.choose.result.length === 0
        ) {
          this.$refs.listCont.changeFlag2();
          this.$store.commit("choose/setFlag3", false);
          this.$store.commit("choose/setDelWord", "选择删除");
          this.$store.commit("choose/setResult", []);
          this.clearResult();
        } else if (
          this.$store.state.choose.flag3 === true &&
          this.$store.state.choose.lists.length > 0 &&
          this.$store.state.choose.result.length > 0
        ) {
          let list = this.$store.state.choose.result;
          if (list.length > 0) {
            this.delListtotal = list.length;
            this.$dialog
              .confirm({
                title: "提示",
                message: `您确定删除此文件夹下的选中文件吗?`,
              })
              .then(() => {
                this.$http
                  .reqRemoveFilesByList(this.folderid, list)
                  .then((response) => {
                    if (response.rtncode === 1) {
                      if (response.rltcode === 1) {
                        if (
                          this.tagid ||
                          this.stime ||
                          this.etime ||
                          this.searchText
                        ) {
                          this.getData(
                            this.tagid,
                            this.stime,
                            this.etime,
                            this.searchText
                          );
                        } else {
                          this.getData();
                          this.$refs.classification.alertBar2();
                        }

                        this.$notify({
                          color: "#fff",
                          background: "#F27852",
                          message: "删除成功",
                          duration: 3000,
                        });
                        this.delSuccess = true
                        this.backStatus();
                      }
                    }
                  });
              })
              .catch(() => {
                // on cancel
              });
          }
        }
      }
    },
    // 清除时间和搜索框的内容
    clearMsg() {
      this.$refs.searchBox.clearMsg();
    },
    // 恢复选择的状态
    backStatus() {
      this.$refs.listCont.changeFlag2();
      this.$store.commit("choose/setFlag3", false);
      this.$store.commit("choose/setDelWord", "选择删除");
      this.$store.commit("choose/setResult", []);
    },
    clearFlag() {
      this.$refs.listCont.changeFlag2();
      this.$store.commit("choose/setFlag3", false);
      this.$store.commit("choose/setDelWord", "选择删除");
      this.$store.dispatch("choose/updateLists", []);
    },
    clearResult() {
      this.$refs.listCont.toggle([]);
    },
    closePopup() {
      this.showSearchPopup = false;
    },
    clearFolderid() {
      this.flag = false;
      this.lists = [];
      this.tagpc = [];
      this.breadList = [];
      this.currentPage = 1;
      this.clearData();
      this.folderid = "";
      this.getData("", "", "", "");
      this.$refs.classification.alertBars1();
    },
    // 文件夹操作
    dirhandler(dir) {
      this.docFolidOperateShow = true;
      this.docFolidInfo = dir;
      console.log(dir);
    },

    changePotence(val) {
      this.currentPage = 1;
      this.potence = val;
      this.SearchTimes = 1;
      this.isFilter = false;
      // this.tagid = "";
      if (this.folderid) {
        this.getData(this.tagid, this.stime, this.etime, this.searchText);
      } else {
        return this.$notify({
          color: "#fff",
          background: "#F27852",
          message: "请先选择文件夹",
          duration: 5000,
        });
      }
    },
    updateChangeFilter(value) {
      this.changeFilter = value;
    },
  },

  watch: {
    classifytag(newval, oldval) {
      console.log("改变classfy======", newval, oldval);
      this.classifyresult = [];
      if (this.minlock !== 0 && this.minlock !== undefined) {
        sortclassify(newval, this.classifyresult, this.minlock);
      }
    },
  },
  destroyed() {
    this.$store.commit("choose/setFlag3", false);
    this.$store.commit("choose/setDelWord", "选择删除");
    this.$store.dispatch("choose/updateLists", []);
    this.$store.commit("choose/setResult", []);
  },
};
</script>

<style lang="less" scoped>
/deep/.van-popup {
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
}
#smartcloud {
  display: flex;
  flex-direction: column;
  /deep/.van-sticky {
    display: flex;
    background-color:#fff;
    align-items: center;
    padding-left: 20px;
    .van-cell {
      padding: 10px 20px 10px 8px;
    }
  }
  /deep/.van-nav-bar__title {
    background-color:#fcecdb;
    padding: 0 5px;
  }
  /deep/.van-cell__title {
    flex: 2;
  }
  .top {
    flex: 1;
    margin-bottom: 90px;
  }
  /deep/.van-popup__close-icon--top-right {
    color: #000000;
  }
  .selectNavS {
    padding: 20px 20px 0px 20px;
    .title-wapper {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-top: 10px;
      .notice-wapper {
        display: flex;
        justify-content: space-between;
        align-items: center;
        .check-file {
          color:#69707C;
          margin-left: 5px;
        }
      }
    }
  }
  .marginStyleWapper {
    margin-top: 15px;
    .file-list-wapper {
      display: flex;
      justify-content: space-between;
      align-items: center;
      .file-list-total {
        display: flex;
        justify-content: space-between;
        align-items: center;
        color: #000000;
        font-weight: bold;
        /deep/.van-icon {
          margin-top: 1px;
        }
      }
    }
  }
  .marginStyle {
    margin-top: 5px;
    height: calc(100vh - 380px);
    overflow-y: auto;
  }
  .sureBtn {
    text-align: center;
    margin-top: 15px;
    border-radius: 30px;
  }
  
  .file {
    font-size: 14px;
    .fileList {
      display: flex;
      justify-content: space-between;
      padding: 12px 20px;
      border-bottom: 1px solid #f3f3f3;
      img {
        margin-right: 10px;
      }
      a {
        position: relative;
        top: -3px;
        color: #333;
      }
      &:first-child {
        margin-top: 10px;
      }
    }
    .active {
      background: #ecf9ff;
    }
    .noDir {
      padding: 20px;
      text-align: center;
    }
  }
  .van-nav-bar__left {
    padding: 0;
  }
  .build-block {
    text-align: center;
    .a-item {
      margin: 10px 20px;
      padding: 6px 0;
    }
    .a-cancel {
      border-top: 1px solid#f5f3f3;
      height: 50px;
      line-height: 50px;
    }
  }
  .new-file-field {
    /deep/.van-field__body {
      border: 1px solid #ECB23A;
      text-align: center;
      padding: 2px;
    }
    /deep/.van-button__text {
      color:#ECB23A;
    }
  }
  .build-block-item {
    text-align: center;
    .a-item {
      margin: 10px 20px 0 20px;
      border-bottom: 1px solid #F5F5F5;
      padding-bottom: 15px;
    }
    .a-item-rename{
      margin: 10px 20px;
      padding-bottom: 10px;
    }
    .a-cancel {
      height: 50px;
      line-height: 45px;
      border-top: 10px solid#EAEAEC;
    }
  }

  .move-block {
    display: flex;
    flex-direction: column;
    overflow-y: scroll;
    padding: 50px 20px 0 20px;
    height: 100vh;
    .move-block-title {
      color: #000;
      display: flex;
      align-items: center;
      font-weight: bold;
    }
    .move-block-content {
      height: calc(100vh - 11rem);
      overflow-y: auto;
    }
    .move-block-item {
      margin: 10px 0 10px 0;
      position: relative;
    }
    .move-block-item-no {
      margin: 30px 0 0 30px;
      position: relative;
    }
    img {
      width: 20px;
      height: 20px;
      margin: 0 10px;
    }
    .move-btn-wapper {
      position: absolute;
      bottom: 20px;
      left: 0;
      right: 0;
      text-align: center;
      padding: 0 30px;
      .cancel-btn {
        margin: 30px 10px 0 0;
        border-radius: 30px;
        width: 80px;
        color: #fff;
        background-color: #cfa477;
      }
      .move-btn {
        margin: 30px 10px 0 0;
        border-radius: 30px;
        width: 80px;
      }
    }
  }
}
</style>
<style lang="less">
.van-dialog__message {
  text-align: left;
}
.van-dialog__message {
  text-align: left;
}
.van-nav-bar__title {
  font-weight: 700;
}
.van-action-sheet__cancel {
  font-size: 0.4rem;
  background: #907456;
  color: #fff;
}
.closeIcon {
  position: absolute;
  font-size: 0.58667rem;
  right: 0.42667rem;
  top: -20px;
}
.showActiveSheetContent {
  padding: 0;
  box-sizing: border-box;
  
  .item {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 1.33333rem;
    padding: 0;
    font-size: 0.36rem;
    line-height: 0.53333rem;
    background-color: #fff;
    border: none;
    cursor: pointer;
    .word {
      font-size: 0.36rem;
      line-height: 0.53333rem;
    }
    .img {
      width: 20px;
      height: 20px;
      margin-right: 8px;
    }
    &:active {
      background-color: #f2f3f5;
    }
  }
  .item-line:nth-child(odd) {
    // border-bottom-width: 0.02667rem;
    border-bottom: 1px solid #ebedf0;
  }
  .item-cancel {
    border-top: 8px solid#EAEAEC;
  }
}
.classify-nav-box {
  display: flex;
  padding: 0 6px;
  overflow-x: scroll;
  overflow-y: hidden;
  background-color: #fff;
  margin-bottom: 1px;

  // margin-bottom: 2px;
  .classify-nav-item {
    display: flex;
    align-items: center;
    .classify-nav-content {
      display: flex;
      padding: 0 0 0 6px;
      white-space: nowrap;
      height: 24px;
      font-size: 12px;
      color: #cb9728;
      line-height: 24px;
      background-color: #fff;
      &::after {
        margin-left: 4px;
        content: ">";
        color: #666;
      }
    }
    &:last-child {
      .classify-nav-content {
        &::after {
          content: "";
        }
      }
    }
    .sanjiao {
      margin-right: 4px;
      border-top: 10px solid transparent;
      border-left: 10px solid #fff;
      border-bottom: 10px solid transparent;
      filter: drop-shadow(2px 2px 10px rgba(0, 0, 0, 0.1));
    }
  }
}
</style>
